const riot = require('riot');

riot.tag2('page-webhooks-single', '<div class="f"> <div class="h100vh sticky t0" data-is="module-sidebar"></div> <form class="w-full f fclm bg-pale_gray" if="{isShow}" onsubmit="{submit}"> <div class="flex-fixed bg-white" data-is="module-page-header" project="{project}" title="Webhookテンプレートの{!projectWebhookSetting ? &quot;新規作成&quot; : &quot;編集&quot;}" back="{true}" breadcrumbs="{breadcrumbs}"> <yield to="right"> <button class="button primary" if="{parent.hasPermission}">保存</button> </yield> </div> <div class="f fclm px40 py36"> <div class="bg-white rounded-8 elevation-default-low"> <div class="section-padding"> <label class="block mb20"> <div class="f fm mb8"> <div class="ts-hxs text-gray_80 mr4">Webhookテンプレート名</div> <div class="ts-hxxs text-pink_70">必須</div> </div> <div class="ts-pxs text-gray_60 mb8">このWebhookテンプレートに名前をつけて管理できます。</div> <input class="input w-full" ref="name" type="text" required placeholder="名前を入力" oninput="{dataChange}" riot-value="{projectWebhookSetting?.name}" disabled="{!hasPermission}"> </label> <label class="block mb20"> <div class="f fm mb8"> <div class="ts-hxs text-gray_80 mr4">URL</div> <div class="ts-hxxs text-pink_70">必須</div> </div> <div class="ts-pxs text-gray_60 mb8">Webhookを受け取るURLです。\\{\\{}}で囲むことで変数が入力できます。</div> <input class="input w-full" ref="webhook_endpoint" type="text" required placeholder="URLを入力" oninput="{dataChange}" riot-value="{projectWebhookSetting?.webhook_endpoint}" disabled="{!hasPermission}"> </label> <div class="mb20" data-is="module-webhook-headers" headers="{headerJSON}" ref="headers" disabled="{!hasPermission}"></div> <label class="block"> <div class="f fm mb8"> <div class="ts-hxs text-gray_80 mr4">Body</div> </div> <div class="ts-pxs text-gray_60 mb8">送信される配布イベントの内容を設定できます。\\{\\{}}で囲むことで変数が入力できます。<br>Bodyは"Content-Type: application/json; charset=utf-8"にて送信されます</div> <textarea class="input w-full min-height-370" ref="body_template" type="text" oninput="{resizeTextarea}" riot-value="{projectWebhookSetting ? projectWebhookSetting.body_template : app.data.constants.webhook_body_template_sample}" disabled="{!hasPermission}"></textarea> </label> </div> <div class="px32"> <div class="ts-hxs text-gray_80 mb12">利用可能な変数</div> </div> <div class="pb32" data-is="module-table" schemas="{tableSchemas}" items="{app.data.constants.webhook_body_templates}"></div> </div> </div> </form> </div>', 'page-webhooks-single,[data-is="page-webhooks-single"]{display:block}', '', function(opts) {
    this.tableSchemas = [
      {
        id: 'id',
        label: '変数',
        class: 'w284 flex-fixed',
      },
      {
        id: 'description',
        label: '説明',
        class: 'min-width-200 w0 flex-auto',
      },
      {
        id: 'type',
        label: '型',
        class: 'w84 flex-fixed',
      },
      {
        id: 'event_type',
        label: '対応イベント種類',
        class: 'w220 flex-fixed',
      },
    ];

    this.preload = async ({req, res}) => {
      var companyId = req.params.company_id;
      var projectId = req.params.project_id;
      var webhook_id = req.params.webhook_id;
      var is_new = webhook_id === 'new';

      var hasPermission = app.utils.permission.has('project_writer', { company_id: companyId, project_id: projectId});

      var breadcrumbs = [
        {
          link: `/app/companies/${companyId}/projects/${projectId}/webhooks`,
          label: 'Webhookテンプレート管理',
        },
      ];

      if (!is_new) {
        var { project_webhook_setting } = await app.api.child(`companies/${companyId}/projects/${projectId}/project_webhook_settings/${webhook_id}`).get({});
        var header_json = JSON.parse(project_webhook_setting.header_json);
      }

      return {
        companyId,
        projectId,
        projectWebhookSetting: project_webhook_setting,
        headerJSON: header_json,
        breadcrumbs,
        hasPermission,
      };
    };

    this.on('beforeunload', async (e) => {
      if (this.isChange) {
        e.returnValue = app.data.beforeunload_text;
      }
    });

    this.on('datachange', () => {
      this.dataChange();
    });

    this.on('show', () => {
      this.reset();
    });

    this.submit = async (e) => {
      e.preventDefault();
      var indicator = spat.modal.indicator();

      var body_template = this.refs.body_template.value.trim() || '{}';

      var query = {
        body_template,

        event_type: app.data.constants.webhook_event_types[0].id,
        headers: this.refs.headers.getValue(),

        http_method: "POST",
        name: this.refs.name.value,
        webhook_endpoint: this.refs.webhook_endpoint.value,
      };

      try {
        var api = app.api.child(`companies/${this.companyId}/projects/${this.projectId}/project_webhook_settings`);

        if (this.projectWebhookSetting) {
          var { project_webhook_setting } = await api.child(this.projectWebhookSetting.id).put(query);
        }

        else {
          var { project_webhook_setting } = await api.post(query);
        }
        spat.router.push(`/app/companies/${this.companyId}/projects/${this.projectId}/webhooks`);
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.resizeTextarea = () => {
      const DEFAULT_HEIGHT = 500;
      var $textarea = this.refs.body_template;
      var one_line_height = getComputedStyle($textarea).lineHeight;
      $textarea.style.height = one_line_height;
      $textarea.style.height = ($textarea.scrollHeight || DEFAULT_HEIGHT) + 1 + 'px';
      this.dataChange();
    };

    this.dataChange = () => {
      this.isChange = true;
    };

    this.reset = () => {

      this.update({ isShow: false });
      this.update({
        isShow: true,
        isChange: false,
      });
    };
});